import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom-v5-compat';
import { Text, TextType } from 'ui-components/components/text';
import style from './supplier-breadcrumb.module.less';
import { messages } from './supplier-breadcrumb.messages';
import { SuppliersBaseRoute } from '../suppliers-routes';
import type { Supplier } from '../types/supplier-types';
import { FlexRow } from 'ui-components/components/flex';

type SupplierBreadcrumbProps = {
  supplier: Supplier | null;
};

export const SupplierBreadcrumb = ({ supplier }: SupplierBreadcrumbProps) => {
  const intl = useIntl();
  return (
    <FlexRow className={style.breadcrumb}>
      <Link className={style.link} to={SuppliersBaseRoute}>
        <Text className={style['breadcrumb-font']} textType={TextType.Paragraph} value={messages.supplierBreadcrumb} />
      </Link>
      <Text
        className={style['breadcrumb-font']}
        textType={TextType.Paragraph}
        value={intl.formatMessage(messages.supplier, {
          supplierName: supplier?.supplierName,
        })}
      />
    </FlexRow>
  );
};
